import type { ReactElement } from 'react';

import { useBetOnAllEnabled } from '../../../../store/apiHooks/useBetOnAllEnabled';
import { useGameStateSlice } from '../../../../store/slices/game/selectors';
import type { GameButtonProps } from '../../gameButton/gameButton';

import { BetOnAllControl } from './BetOnAllControl';

export interface BetOnAllControlConnectedProps extends Omit<GameButtonProps, 'icon'> {
  tooltip?: string;
}

export const BetOnAllControlConnected = ({ disabled, ...rest }: BetOnAllControlConnectedProps): ReactElement => {
  const isBetOnAllEnabled = useBetOnAllEnabled();

  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();

  return <BetOnAllControl disabled={disabled || !isBetsOpenStatus || !isBetOnAllEnabled} {...rest} />;
};
